import { useGetVisitOptionsForAFlow as useGeneratedGetVisitOptionsForAFlow } from "@/api/generated";
import { useLocalPartnerIntent } from "@/hooks/useLocalPartnerIntent";

type UseGetVisitOptionsForAFlowArgs = {
  clinicRequestId?: string;
  // Narrows the flow's modalities to those the progression has determined are allowed. Omit at the
  // entry offer card, which has no progression yet.
  userProgressionId?: string;
  enabled?: boolean;
  flowName?: string;
};

export const useGetVisitOptionsForAFlow = ({
  clinicRequestId,
  userProgressionId,
  enabled = true,
  flowName = "",
}: UseGetVisitOptionsForAFlowArgs) => {
  // Previews partner pricing before affiliation; held until read so default prices don't flash.
  const partnerIntent = useLocalPartnerIntent();
  return useGeneratedGetVisitOptionsForAFlow(
    flowName,
    {
      ...(clinicRequestId ? { clinic_request_id: clinicRequestId } : {}),
      ...(userProgressionId ? { user_progression_id: userProgressionId } : {}),
      ...(partnerIntent ? { partner_intent: partnerIntent } : {}),
    },
    {
      query: {
        enabled: enabled && Boolean(flowName) && partnerIntent !== undefined,
        select: (data) => ({
          productOptions: data.product_options ?? [],
          visitOptions: data.visit_options ?? [],
        }),
      },
    },
  );
};
